import { render } from "./SkeletonCrudTable.vue?vue&type=template&id=58a9522c&ts=true"
import script from "./SkeletonCrudTable.vue?vue&type=script&lang=ts"
export * from "./SkeletonCrudTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/common/infrastructure/componentes/base/common/skeleton/SkeletonCrudTable.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58a9522c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58a9522c', __exports__)) {
    api.reload('58a9522c', __exports__)
  }
  
  module.hot.accept("./SkeletonCrudTable.vue?vue&type=template&id=58a9522c&ts=true", () => {
    api.rerender('58a9522c', render)
  })

}


export default __exports__